import AddTickerModal from '@components/settings/add-ticker-modal.component';

const SummarizeEarningsCalls = ({ disclosure }) => <AddTickerModal disclosure={disclosure} />;
export default SummarizeEarningsCalls;
